import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import Table from "../../../../../../core/pagination/datatable";
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Swal from "sweetalert2";
import { Select, Spin } from "antd";

const ProfileTab = () => {
  const dataSource = useSelector(
    (state) => state.rootReducer.applicant_tracking_applicants_dat,
  );
  const columns = [
    {
      title: "Staff Member",
      dataIndex: "Member",
      sorter: (a, b) => a.Member?.length - b.Member?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },

    {
      title: "Date",
      dataIndex: "Date Assigned",
      sorter: (a, b) => a.Date?.length - b.Date?.length,
    },

    {
      title: "Options",
      render: () => (
        <button className="btn btn-outlined">
          <i className="fa-solid fa-trash"></i>
        </button>
      ),
    },
  ];

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  console.log(userId, id);

  const [isEditing, setIsEditing] = useState(
    searchParams.get("edit") === "true",
  );
  const [customerData, setCustomerData] = useState({});

  const [customerLoading, setCustomerLoading] = useState(false);
  const getCustomerDetails = async () => {
    try {
      setCustomerLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${id}`,
      );

      if (response.data.Status) {
        setCustomerData(response.data.ResultData?.[0] || {});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unable to fetch customer details.",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCustomerLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getCustomerDetails();
    }
  }, [id]);

  const getCustomFieldValue = (fieldId) => {
    return (
      customerData?.CustomFields?.find((item) => item.FieldId === fieldId)
        ?.Value || "-"
    );
  };

  const renderGroups = () => {
    if (!customerData?.Groupss?.length) return "-";

    return customerData.Groupss.map((group) => (
      <span key={group.Id} className="badge bg-primary me-2 mb-1">
        {group.GroupName}
      </span>
    ));
  };

  // edit customer integration
  const [activeTab, setActiveTab] = useState(0);
  const handleNext = () => {
    if (activeTab < 2) {
      setActiveTab((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (activeTab > 0) {
      setActiveTab((prev) => prev - 1);
    }
  };

  const [currencies, setCurrencies] = useState([]);
  const [currencyLoading, setCurrencyLoading] = useState(false);
  console.log(currencyLoading);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  console.log(selectedCurrency);
  const [updating, setUpdating] = useState(false);
  const [customerFormData, setCustomerFormData] = useState({
    clientId: "",
    company: "",
    vat: "",
    phonenumber: "",
    country: null,
    city: "",
    state: "",
    zip: "",
    address: "",
    website: "",
    active: 1,
    leadid: 0,
    addedfrom: 0,

    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    billing_country: null,

    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
    shipping_country: null,

    longitude: "",
    latitude: "",

    default_language: "",
    default_currency: null,
    stripe_id: "",
    registration_confirmed: 1,
    googlelocation: "",
    head_office_flag: 0,

    groups: [],
    customFields: [],
  });

  useEffect(() => {
    if (!customerData) return;

    setCustomerFormData({
      clientId: customerData.customerId || 0,
      company: customerData.company || "",
      vat: customerData.vat || "",
      phonenumber: customerData.phonenumber || "",
      country: customerData.country || null,
      city: customerData.city || "",
      state: customerData.state || "",
      zip: customerData.zip || "",
      address: customerData.address || "",
      website: customerData.website || "",
      active: customerData.active ?? 1,
      leadid: customerData.leadid || 0,
      addedfrom: customerData.addedfrom || 0,

      billing_street: customerData.billing_street || "",
      billing_city: customerData.billing_city || "",
      billing_state: customerData.billing_state || "",
      billing_zip: customerData.billing_zip || "",
      billing_country: customerData.billing_country || null,

      shipping_street: customerData.shipping_street || "",
      shipping_city: customerData.shipping_city || "",
      shipping_state: customerData.shipping_state || "",
      shipping_zip: customerData.shipping_zip || "",
      shipping_country: customerData.shipping_country || null,

      longitude: customerData.longitude || "",
      latitude: customerData.latitude || "",

      default_language: customerData.default_language || "english",
      default_currency: customerData.default_currency
        ? Number(customerData.default_currency)
        : 5,
      stripe_id: customerData.stripe_id || "",
      registration_confirmed: customerData.registration_confirmed ?? 1,
      googlelocation: customerData.googlelocation || "",
      head_office_flag: customerData.head_office_flag ?? 0,

      // groups: customerData.CustomerGroups?.map((g) => g.GroupId) || [],
      groups: customerData.Groupss
        ? customerData.Groupss.map((item) => item.GroupId)
        : [],

      customFields: customerData.CustomFields || [],
    });
  }, [customerData]);

  const updateCustomer = async () => {
    setUpdating(true);
    console.log(
      "customerFormData.customFields:",
      customerFormData.customFields,
    );
    try {
      const payload = {
        clientId: customerFormData.clientId,
        company: customerFormData.company,
        vat: customerFormData.vat,
        phonenumber: customerFormData.phonenumber,
        country: customerFormData.country,
        city: customerFormData.city,
        state: customerFormData.state,
        zip: customerFormData.zip,
        address: customerFormData.address,
        website: customerFormData.website,
        active: customerFormData.active,
        leadid: customerFormData.leadid || 0,
        addedfrom: userId,

        billing_street: customerFormData.billing_street,
        billing_city: customerFormData.billing_city,
        billing_state: customerFormData.billing_state,
        billing_zip: customerFormData.billing_zip,
        billing_country: customerFormData.billing_country,

        shipping_street: customerFormData.shipping_street,
        shipping_city: customerFormData.shipping_city,
        shipping_state: customerFormData.shipping_state,
        shipping_zip: customerFormData.shipping_zip,
        shipping_country: customerFormData.shipping_country,

        longitude: customerFormData.longitude || "",
        latitude: customerFormData.latitude || "",

        default_language: customerFormData.default_language,
        default_currency: customerFormData.default_currency,

        stripe_id: customerFormData.stripe_id || "",
        registration_confirmed: customerFormData.registration_confirmed ?? 1,
        googlelocation: customerFormData.googlelocation || "",
        head_office_flag: customerFormData.head_office_flag || 0,

        groups: customerFormData.groups || [],

        customFields:
          customerFormData.customFields?.map((item) => ({
            fieldId: item.FieldId,
            value: item.Value,
          })) || [],
      };

      console.log("Payload:", payload);
      console.log("payload.customFields:", payload.customFields);

      const response = await axios.post(
        `${BASE_CRM_URL}customers/UpdateWebCustomer`,
        payload,
      );

      if (response.data.Status) {
        Swal.fire({
          title: "Success",
          text: response.data.Message || "Customer updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setIsEditing(false);
          getCustomerDetails();
        });
      } else {
        Swal.fire({
          title: "Warning",
          text: response.data.Message || "Unable to update customer.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Update Customer Error:", error);
    } finally {
      setUpdating(false);
    }
  };

  console.log(customerData, "customerData..........");
  console.log(customerFormData, "customerFormData..........");

  const [groupOptions, setGroupOptions] = useState([]);
  const [countries, setCountries] = useState([]);

  console.log(groupOptions, "....................");

  const getCustomerGroups = async () => {
    try {
      const response = await axios.get(`${BASE_CRM_URL}customers/GetGroups`);

      if (response.data.Status) {
        setGroupOptions(
          response.data.ResultData.map((item) => ({
            value: item.id,
            label: item.name,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getCountries = async () => {
    // setCountryLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}GetCountries`);

      if (response.data.Status) {
        setCountries(response.data.ResultData || []);
      }
    } catch (error) {
      console.error("Country API Error:", error);
    }
    //  finally {
    //   setCountryLoading(false);
    // }
  };

  const getCurrencies = async () => {
    try {
      setCurrencyLoading(true);

      const response = await fetch(`${BASE_CRM_URL}/GetCurrencies`);
      const data = await response.json(); // <-- Parse JSON

      console.log(data);

      if (data.Status) {
        const options = data.Data.map((item) => ({
          value: item.id,
          label: `${item.symbol} ${item.name}`,
        }));

        console.log(options);

        setCurrencies(options);

        if (options.length > 0) {
          setSelectedCurrency(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  const countryOptions = countries.map((country) => ({
    value: Number(country.country_id),
    label: country.short_name,
  }));

  useEffect(() => {
    getCustomerGroups();
    getCountries();
    getCurrencies();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setCustomerFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleGroupsChange = (selectedOptions) => {
  //   setCustomerFormData((prev) => ({
  //     ...prev,
  //     groups: selectedOptions ? selectedOptions.map((item) => item.value) : [],
  //   }));
  // };

  const getCustomFieldValueedit = (fieldId) => {
    const field = customerFormData?.customFields?.find(
      (item) => Number(item.FieldId) === Number(fieldId),
    );

    return field?.Value ?? "";
  };

  const handleCustomFieldChange = (fieldId, value) => {
    setCustomerFormData((prev) => {
      const customFields = [...(prev.customFields || [])];

      const index = customFields.findIndex(
        (field) => Number(field.FieldId) === Number(fieldId),
      );

      if (index > -1) {
        customFields[index] = {
          ...customFields[index],
          Value: value,
        };
      } else {
        customFields.push({
          FieldId: fieldId,
          Value: value,
        });
      }

      return {
        ...prev,
        customFields,
      };
    });
  };

  useEffect(() => {
    console.log("customerData.Groupss", customerData?.Groupss);
    console.log("customerFormData.groups", customerFormData.groups);
  }, [customerData, customerFormData.groups]);

  return (
    <>
      {!isEditing && (
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Customer Details</h5>

            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setIsEditing(true)}
            >
              <i className="fa fa-edit"></i>
            </button>
          </div>
          <Spin spinning={customerLoading}>
            {/* Customer View Card */}

            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Company :</strong> {customerData?.company || "-"}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>GSTIN :</strong> {customerData.vat || "-"}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Phone :</strong> {customerData?.phonenumber || "-"}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Groups :</strong> <span>{renderGroups()}</span>
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Currency :</strong> {customerData.currencyName || "-"}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Default Language :</strong>{" "}
                  {customerData.default_language || "-"}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Website :</strong> {customerData?.website || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>City :</strong> {customerData.city || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>State :</strong> {customerData.state || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Zipcode :</strong> {customerData.zip || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Country :</strong> {customerData.countryName || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Address :</strong> {customerData.address || "-"}
                </div>
                {/* <div className="col-md-6 mb-2">
                    <strong>Show Primary Contact :</strong> Yes
                  </div> */}
              </div>
              <hr />
              <div className="row">
                <h5 className="mb-3">Additional Details</h5>

                <div className="col-md-6 mb-2">
                  <strong>Client Name :</strong> {getCustomFieldValue(5)}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Client ID :</strong> {customerData?.customerId || "-"}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Renewal Date :</strong> {getCustomFieldValue(6)}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>AMC Amount :</strong> {getCustomFieldValue(7)}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Last Payment :</strong> {getCustomFieldValue(15)}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Count Staff / Terminals :</strong>{" "}
                  {getCustomFieldValue(9)}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Location :</strong> {getCustomFieldValue(10)}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Subscription :</strong>{" "}
                  {getCustomFieldValue(16) === "1"
                    ? "Yes"
                    : getCustomFieldValue(16) === "0"
                      ? "No"
                      : "-"}
                </div>
              </div>
              <hr></hr>
              <div className="row">
                {/* Billing Address */}
                <div className="col-12 col-lg-6 border-end">
                  <h6 className="mb-3">
                    <i className="fa-solid fa-receipt me-2 text-primary"></i>
                    Billing Address
                  </h6>

                  <div className="mb-2">
                    <strong>Street :</strong>{" "}
                    {customerData.billing_street || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>City :</strong> {customerData.billing_city || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>State :</strong> {customerData.billing_state || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>Zipcode :</strong> {customerData.billing_zip || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>Country :</strong>{" "}
                    {customerData.billingCountryName || "-"}
                  </div>
                </div>

                {/* Shipping Address */}
                <div className="col-12 col-lg-6">
                  <h6 className="mb-3">
                    <i className="fa-solid fa-truck-fast me-2 text-success"></i>
                    Shipping Address
                  </h6>

                  <div className="mb-2">
                    <strong>Street :</strong>{" "}
                    {customerData.shipping_street || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>City :</strong> {customerData.shipping_city || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>State :</strong>{" "}
                    {customerData.shipping_state || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>Zipcode :</strong>{" "}
                    {customerData.shipping_zip || "-"}
                  </div>

                  <div className="mb-2">
                    <strong>Country :</strong>{" "}
                    {customerData.shippingCountryName || "-"}
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      )}

      {isEditing && (
        <div>
          <ul className="nav nav-tabs nav-tabs-bottom mb-3">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link border-0 bg-transparent px-3 ${
                  activeTab === 0 ? "text-primary active-tab" : "text-secondary"
                }`}
                onClick={() => setActiveTab(0)}
              >
                Customer Details
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link border-0 bg-transparent px-3 ${
                  activeTab === 1 ? "text-primary active-tab" : "text-secondary"
                }`}
                onClick={() => setActiveTab(1)}
              >
                Additional Details
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link border-0 bg-transparent px-3 ${
                  activeTab === 2 ? "text-primary active-tab" : "text-secondary"
                }`}
                onClick={() => setActiveTab(2)}
              >
                Billing & Shipping
              </button>
            </li>

            <li className="ms-auto">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setIsEditing(false)}
                title="View Details"
              >
                <i className="fa-solid fa-eye me-1"></i>
              </button>
            </li>
          </ul>

          <div className="tab-content">
            <div
              className={`tab-pane ${activeTab === 0 ? "show active" : ""}`}
              id="Customer_Details"
            >
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Company</label>
                  <input
                    type="text"
                    className="form-control"
                    name="company"
                    value={customerFormData.company}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">GSTIN</label>
                  <input
                    type="text"
                    className="form-control"
                    name="vat"
                    value={customerFormData.vat}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phonenumber"
                    value={customerFormData.phonenumber}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">website</label>
                  <input
                    type="text"
                    className="form-control"
                    name="website"
                    value={customerFormData.website}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 col-md-6 col-lg-6 mb-3">
                  <label className="form-label">Groups</label>
                  <Select
                    mode="multiple"
                    className="w-100"
                    // style={{ height: 10 }}
                    options={groupOptions}
                    value={customerFormData.groups}
                    onChange={(value) =>
                      setCustomerFormData((prev) => ({
                        ...prev,
                        groups: value,
                      }))
                    }
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Currency</label>
                  {/* <Select
                    className="w-100"
                    options={currencies}
                    value={currencies.find(
                      (option) =>
                        option.value === customerFormData.default_currency,
                    )}
                    onChange={(option) => {
                      console.log(option,"optionsssssssssssssssssssssssssssssssssss")
                      setSelectedCurrency(option);

                      setCustomerFormData((prev) => ({
                        ...prev,
                        default_currency: option?.value,
                      }));
                    }}
                    placeholder="Choose"
                    isLoading={currencyLoading}
                  /> */}

                  <Select
                    className="w-100"
                    style={{ height: 38 }}
                    options={currencies}
                    value={
                      customerFormData.default_currency
                        ? Number(customerFormData.default_currency)
                        : undefined
                    }
                    onChange={(value) => {
                      console.log("Selected currency ID:", value);

                      setCustomerFormData((prev) => ({
                        ...prev,
                        default_currency: value ? Number(value) : null,
                      }));
                    }}
                    placeholder="Choose"
                    loading={currencyLoading}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Default Language</label>
                  <input
                    type="text"
                    className="form-control"
                    name="default_language"
                    value={customerFormData.default_language || ""}
                    onChange={(e) =>
                      setCustomerFormData((prev) => ({
                        ...prev,
                        default_language: e.target.value,
                      }))
                    }
                    placeholder="Enter Language"
                  />
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={customerFormData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">State</label>
                  <input
                    type="text"
                    className="form-control"
                    name="state"
                    value={customerFormData.state}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Zipcode</label>
                  <input
                    type="text"
                    className="form-control"
                    name="zip"
                    value={customerFormData.zip}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <label className="form-label">Country</label>
                  <Select
                    options={countryOptions}
                    style={{ height: 38 }}
                    className="w-100"
                    value={customerFormData.country}
                    onChange={(value) =>
                      setCustomerFormData((prev) => ({
                        ...prev,
                        country: value,
                      }))
                    }
                  />
                </div>
                <div className="col-12  mb-3">
                  <label className="form-label">Address</label>
                  <textarea
                    type="text"
                    rows={2}
                    className="form-control"
                    name="address"
                    value={customerFormData.address}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`tab-pane ${activeTab === 1 ? "show active" : ""}`}
              id="Custom_Fields"
            >
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Client Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={getCustomFieldValueedit(5)}
                    onChange={(e) => handleCustomFieldChange(5, e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">ClientId</label>
                  <input
                    type="text"
                    className="form-control"
                    value={getCustomFieldValueedit(4)}
                    onChange={(e) => handleCustomFieldChange(4, e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Renewal Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={getCustomFieldValueedit(6)}
                    onChange={(e) => handleCustomFieldChange(6, e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">AMC Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={getCustomFieldValueedit(7)}
                    onChange={(e) => handleCustomFieldChange(7, e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Last Payment</label>
                  <input
                    type="date"
                    className="form-control"
                    value={getCustomFieldValueedit(15)}
                    onChange={(e) =>
                      handleCustomFieldChange(15, e.target.value)
                    }
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">CountStaff/Terminals</label>
                  <input
                    type="text"
                    className="form-control"
                    value={getCustomFieldValueedit(9)}
                    onChange={(e) => handleCustomFieldChange(9, e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    value={getCustomFieldValueedit(10)}
                    onChange={(e) =>
                      handleCustomFieldChange(10, e.target.value)
                    }
                  />
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label d-block">Subscription</label>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="subscription"
                      checked={getCustomFieldValueedit(16) === "1"}
                      onChange={() => handleCustomFieldChange(16, "1")}
                    />
                    <label className="form-check-label">Yes</label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="subscription"
                      checked={getCustomFieldValueedit(16) === "0"}
                      onChange={() => handleCustomFieldChange(16, "0")}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane ${activeTab === 2 ? "show active" : ""}`}
              id="Billing"
            >
              <div className="row">
                <div className="col-12 col-lg-6 border-end">
                  <p>
                    <i className="fa-solid fa-receipt me-2"></i>Billing Address
                  </p>
                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Street</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billing_street"
                          value={customerFormData.billing_street}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billing_city"
                          value={customerFormData.billing_city}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billing_state"
                          value={customerFormData.billing_state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">Zipcode</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billing_zip"
                          value={customerFormData.billing_zip}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">Country</label>
                        <Select
                          options={countryOptions}
                          className="w-100"
                          value={customerFormData.billing_country}
                          onChange={(value) =>
                            setCustomerFormData((prev) => ({
                              ...prev,
                              billing_country: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <p>
                    <i className="fa-solid fa-truck-fast me-2"></i>Shipping
                    Address
                  </p>
                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Street</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipping_street"
                          value={customerFormData.shipping_street}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipping_city"
                          value={customerFormData.shipping_city}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipping_state"
                          value={customerFormData.shipping_state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">Zipcode</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipping_zip"
                          value={customerFormData.shipping_zip}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">Country</label>
                        <Select
                          options={countryOptions}
                          className="w-100"
                          value={customerFormData.shipping_country}
                          onChange={(value) =>
                            setCustomerFormData((prev) => ({
                              ...prev,
                              shipping_country: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane" id="Admins">
              <div className="card table-list-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <div className="search-set"></div>
                  <div className="d-flex">
                    <button
                      className="btn btn-secondary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRightNewClient"
                      aria-controls="offcanvasRightNewClient"
                    >
                      Assign Admin
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <Table columns={columns} dataSource={dataSource} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer d-flex mb-0 justify-content-end">
            {/* <button
              className="btn btn-primary"
              onClick={updateCustomer}
              disabled={updating}
            >
              {updating ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                "Save"
              )}
            </button> */}

            <div className="d-flex align-items-center gap-2 ms-auto">
              {/* Close */}
              <button
                type="button"
                // onClick={handleClose}
                // disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#e40d22",
                  color: "#fff",
                  border: "none",
                }}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>

              {/* Back button - only show on tabs 1 and 2 */}
              {activeTab > 0 && (
                <button
                  type="button"
                  onClick={handlePrevious}
                  // disabled={loading}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Previous"
                >
                  <i className="fa fa-arrow-left" />
                </button>
              )}

              {/* Next / Save */}
              {activeTab < 2 ? (
                <button
                  type="button"
                  onClick={handleNext}
                  // disabled={loading}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#0d6efd",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Next"
                >
                  <i className="fa fa-arrow-right" />
                </button>
              ) : (
                <button
                  type="button"
                  onClick={updateCustomer}
                  disabled={updating}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#07f083",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Update"
                >
                  {updating ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                  ) : (
                    <i className="fa fa-check" />
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileTab;
